import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {AllergensModelService} from '../../Models/Core/allergens-model.service';

@Injectable({
  providedIn: 'root'
})
export class AllergensApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: AllergensModelService
  ) {
    super(injector);
  }


  /**
   * Obtener los alérgenos
   *
   */
  public getAllergens(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProductosAlergenos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
